export default {
    _prefix: "qualityFormEditor.question",
    labels: {
        createQuestionTemplate: "Create Question Template",
        templateName: "Template Name",
        addTemplateName: "Add Template Name ...",
        save: "Save",
        cancel: "Cancel",
        saveTemplate: "Save As Template",
        favoriteTemplate: "Make this a favorite template",
    },
    toastMessage: {
        success: {
            message: "Successfully Created Question Template",
            title: "Template Creation Succeeded",
        },
        fail: {
            message: "Failed To Create Question Template",
            title: "Template Creation Failed",
        },
    },
};
